<div class="container card positionCard">
  <div class="row clearfix">
    <div class="col-md-6 col-sm-10 col-md-push-3 tablet-block clearfix">
      <div class="center-block">
        <div class="banner-text-holder">
          <div class="banner-bar-holder">
            <span class="banner-horizontal-yellowbar"></span>
            <span class="banner-vertical-yellowbar"></span>
          </div>
        </div>
        <div class="text-center">
          <div class="errorImg">
            <span>4</span>
            <span class="bgCircle"><img alt="Error image" src="assets/img/svg/error_page_icon.svg"></span>
            <span>4</span>
          </div>
          <div class="divider-line"></div>
          <h3>Something went wrong!</h3>
          <p class="errorText">We’re facing a technical issue. Please tap on resume <br/>
                to continue your application.</p>
        </div>
        <div class="col-md-4 col-sm-6 center-block">
          <button class="btn btn-primary btn-block">Resume</button>
        </div>
      </div>
    </div>
  </div>
</div>
